import { render, staticRenderFns } from "./AgentsDashboard.vue?vue&type=template&id=08849726&scoped=true"
import script from "./AgentsDashboard.vue?vue&type=script&lang=js"
export * from "./AgentsDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgentsDashboard.vue?vue&type=style&index=0&id=08849726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08849726",
  null
  
)

export default component.exports